
var pages = function(){

	/**
	 * [_pages description]
	 * @type {[type]}
	 */
	var app = this;

	/**
	 * [modal description]
	 * @type {[type]}
	 */
	var modal = null;

	/**
	 * [rule description]
	 * @type {[type]}
	 */
	var rule = $('[data-for="rule"]');

	/**
	 * [answer description]
	 * @type {[type]}
	 */
	var answer = $('[data-for="answer"]');

	/**
	 * [definedRules description]
	 * @type {[type]}
	 */
	var definedRules = $('[data-for="defined-rules"]');

	/**
	 * [addRule description]
	 * @type {[type]}
	 */
	var addRule = $('[data-for="add-rule"]');

	/**
	 * [getAnswersRoute description]
	 * @type {[type]}
	 */
	var getAnswersRoute = $('[data-for="get-answers"]').val() + '/';

	/**
	 * [getAdditionalFieldsRoute description]
	 * @type {[type]}
	 */
	var getAdditionalFieldsRoute = $('[data-for="get-additional-fields"]').val() + '/';

	/**
	 * [getReOrderFieldsRoute description]
	 * @type {[type]}
	 */
	var getReOrderFieldsRoute = $('[data-for="re-order-fields"]').val();

	/**
	 * [noRulesDefined description]
	 * @type {[type]}
	 */
	var noRulesDefined = $('<li />').attr('data-for', 'no-rules').text('Currently no rules have been defined, this group will appear on every page');

	/**
	 * [addedCustomFields description]
	 * @type {[type]}
	 */
	var addedCustomFields = $('[data-for="added-custom-fields"]');

	/**
	 * [noCustomFields description]
	 * @type {[type]}
	 */
	var noCustomFields = $( '<tr />' ).append( $( '<td />' ).text( 'No custom fileds have been created' ) ).attr( 'data-for', 'no-custom-fields' );

	/**
	 * [deletePages description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	var deletePages = function(e){
		var button = $(this);
		e.preventDefault();
		swal({
			title: "Are you sure?",
			text: "This action cannot be reversed",
			type: "warning",
			showCancelButton: true,
			confirmButtonClass: 'btn-danger',
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: "No, cancel please!",
			closeOnConfirm: false,
			closeOnCancel: false
		}, function( isConfirm ) {
			if ( isConfirm ) {
				window.location = button.attr('href');
			} else {
				swal.close();
			}
		});
	};

	/**
	 * [swapAnswers description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	var swapAnswers = function(e)
	{
		$.get( getAnswersRoute + $(this).val(), function( response ) {
			answer.html('');
			for( var key in response ) {
				answer.append( $( '<option />' ).val(key).text( response[key] ) );
			}
			answer.prop( 'disabled', false ).dropdown({ on : 'hover' });
		});
	};

	/**
	 * [checkIfDefinedRulesAreEmpty description]
	 * @return {[type]} [description]
	 */
	var checkIfDefinedRulesAreEmpty = function()
	{
		noRulesDefined.remove();
		if( ! $('li', definedRules).length ) {
			$('ul', definedRules).append(noRulesDefined);
		}
	};

	/**
	 * [checkIfCustomFieldsAreEmpty description]
	 * @return {[type]} [description]
	 */
	var checkIfCustomFieldsAreEmpty = function()
	{
		noCustomFields.remove();
		if( ! $( 'tr', addedCustomFields ).length ) {
			addedCustomFields.append( noCustomFields );
		}
	};

	/**
	 * [addRuleToBlock description]
	 * @param {[type]} e [description]
	 */
	var addRuleToBlock = function(e)
	{
		e.preventDefault();
		var _rule = $( '<input />' ).attr( 'type', 'hidden' ).attr( 'name', '_rules[][new][' + rule.val() + ']' ).val( answer.val() );
		switch( parseInt( rule.val() ) ) {
			case 1 : 
				var ruleLine = $('<li />').html( "Display where the page slug is '" + answer.val() + "' <a data-for='delete-group-rule' href='#' class='btn btn-danger btn-sm'><i class='fa fa-trash'></i></a>" ).append( _rule );
			break;
			case 2 : 
				var ruleLine = $('<li />').html( "Display where the page ID is '" + answer.val() + "' <a data-for='delete-group-rule' href='#' class='btn btn-danger btn-sm'><i class='fa fa-trash'></i></a>" ).append( _rule );
			break;
			case 3 : 
				var ruleLine = $('<li />').html( "Display where the page is using template '" + answer.val() + "' <a data-for='delete-group-rule' href='#' class='btn btn-danger btn-sm'><i class='fa fa-trash'></i></a>" ).append( _rule );
			break;
			case 4 : 
				var ruleLine = $('<li />').html( "Display where the page has a parent of '" + answer.val() + "' <a data-for='delete-group-rule' href='#' class='btn btn-danger btn-sm'><i class='fa fa-trash'></i></a>" ).append( _rule );
			break;
		}
		ruleLine.appendTo( $('ul', definedRules ) );
		checkIfDefinedRulesAreEmpty();
		deleteGroupRulesHandler();
	};

	/**
	 * [deleteGroupRulesHandler description]
	 * @return {[type]} [description]
	 */
	var deleteGroupRulesHandler = function()
	{
		$('[data-for="delete-group-rule"]').unbind('click').click( function(e) {
			e.preventDefault();
			var button = $(this);
			if( button.attr( 'href' ) == '#' ) {
				button.parents('li:eq(0)').fadeOut( 200, function(){
					$(this).remove();
					checkIfDefinedRulesAreEmpty();
				});
			} else {
				$.get( button.attr( 'href' ), function( response ) {
					button.parents('li:eq(0)').fadeOut( 200, function(){
						$(this).remove();
						checkIfDefinedRulesAreEmpty();
					});
				});
			}
		});
	};

	/**
	 * [swapAdditionalFields description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	var swapAdditionalFields = function(e, elm, modalObj)
	{
		var additionalPlaceholder = $( '[data-for="additional-placeholder"]', modalObj );
		$( 'form', modalObj ).addClass( 'loading' );
		$.get( getAdditionalFieldsRoute + elm.val(), function( response ) {
			additionalPlaceholder.html( '' );
			$( response ).appendTo( additionalPlaceholder );
			$( 'form', modalObj ).removeClass( 'loading' );
			$.fn.ensphere.veto.refreshModal();
		});
	};

	/**
	 * [bindMiscModalEvents description]
	 * @param  {[type]} modalObj [description]
	 * @return {[type]}          [description]
	 */
	var bindMiscModalEvents = function( modalObj )
	{
		$('[data-for="field-type"]').change( function(e){
			swapAdditionalFields( e, $(this), modalObj );
		});
		$.fn.ensphere.veto.wysiwyg( '.redactor', modalObj );
		$( 'form', modalObj ).removeClass( 'loading' );
		$('[name="label"]', modalObj ).blur( function() {
			if( $('[name="name"]', modalObj ).val() == '' ) {
				$('[name="name"]', modalObj ).val( $.fn.ensphere.veto.slugify( $( '[name="label"]', modalObj ).val() ) );
			}
		});
	}

	/**
	 * [resetOrdering description]
	 * @return {[type]} [description]
	 */
	var resetOrdering = function()
	{
		var order = {};
		$( '[data-for="added-custom-fields"] tr').each( function( index, elm ) {
			order[$(this).attr( 'data-group-field-id' )] = ( index + 1 );
			$( 'td:eq(0) span', $(this) ).text( ( index + 1 ) );
		});
		$.get( getReOrderFieldsRoute, { orders : order }, function( response ) {

		});
	};

	/**
	 * [addCustomFieldRow description]
	 * @param {[type]} response [description]
	 */
	var addCustomFieldRow = function( response )
	{
		var row = $('<tr data-group-field-id="' + response.id + '" />');
		$( '<td data-for="sort"  />' ).html( '<span class="badge">' + response.sort + '</span>' ).appendTo( row );
		$( '<td data-for="label"  />' ).text(  response.label ).appendTo( row );
		$( '<td data-for="name"  />' ).text(  response.name ).appendTo( row );
		$( '<td data-for="type"  />' ).text(  response.type ).appendTo( row );

		var buttons = $( '<div class="btn-group" />' );
		$( '<a data-for="edit-field" class="btn btn-default btn-sm" />' ).attr( 'href', response.edit_url ).append( $( '<i class="fa fa-pencil-square-o" />' ) ).appendTo( buttons );
		$( '<a data-for="delete-field" class="btn btn-danger btn-sm" />' ).attr( 'href', response.delete_url ).append( $( '<i class="fa fa-trash" />' ) ).appendTo( buttons );
			
		$( '<td  />' ).append( buttons ).appendTo( row );

		row.appendTo( $( '[data-for="added-custom-fields"]' ) );
		checkIfCustomFieldsAreEmpty();
		bindEvents();
	};

	/**
	 * [addCustomField description]
	 * @param {[type]} e [description]
	 */
	var addCustomField = function(e)
	{
		e.preventDefault();
        $.fn.ensphere.veto.modalEdit( this, {
			onVisible : function( modalObj ){
				bindMiscModalEvents( modalObj );
			},
			onComplete : function( response, attributes, modal ){
				modal.semanticUiModal( 'hide' );
				addCustomFieldRow( response );
			}
		});
	};

	/**
	 * [updateGroupCustomFieldsRow description]
	 * @param  {[type]} response [description]
	 * @return {[type]}          [description]
	 */
	var updateGroupCustomFieldsRow = function( response )
	{
		var row = $('[data-group-field-id="' + response.id + '"]');
		$( '[data-for="label"]', row ).text( response.label );
		$( '[data-for="name"]', row ).text( response.name );
		$( '[data-for="type"]', row ).text( response.type );
	};

	/**
	 * [editCustomField description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	var editCustomField = function(e)
	{
		e.preventDefault();
		$.fn.ensphere.veto.modalEdit( this, {
			onVisible : function( modalObj ){
				bindMiscModalEvents( modalObj );
			},
			onComplete : function( response, attributes, modal ){
				updateGroupCustomFieldsRow( response );
				modal.semanticUiModal( 'hide' );
			}
		});
	};

	/**
	 * [deleteCustomField description]
	 * @param  {[type]} e [description]
	 * @return {[type]}   [description]
	 */
	var deleteCustomField = function(e)
	{
		e.preventDefault();
		var button = $(this);
		$.get( button.attr( 'href' ), function( response ) {
			button.parents( 'tr:eq(0)' ).fadeOut( 200, function(){
				$(this).remove();
				resetOrdering();
				checkIfCustomFieldsAreEmpty();
			});
		});
	};

	/**
	 * [bindEvents description]
	 * @return {[type]} [description]
	 */
	var bindEvents = function()
	{
		$('.pages.list .trash.icon').parent().unbind( 'click' ).click( deletePages );
		rule.unbind( 'change' ).change( swapAnswers );
		addRule.unbind( 'click' ).click( addRuleToBlock );
		deleteGroupRulesHandler();
		$('[data-for="add-custom-field"]').unbind( 'click' ).click( addCustomField );
		$('[data-for="edit-field"]').unbind( 'click' ).click( editCustomField );
		$('[data-for="delete-field"]').unbind( 'click' ).click( deleteCustomField );
	};

	var bindSortableRows = function()
	{
		if( $( '[data-for="added-custom-fields"]' ).length ) {
			new Sortable( $( '[data-for="added-custom-fields"]' ).get(0), {
				handle: '.handle',
				dragClass: "sortable-drag",
				onEnd: function (e) {
					resetOrdering();
				}
			});
		}
	};

	/**
	 * [init description]
	 * @return {[type]} [description]
	 */
	this.init = function() 
	{
        $.fn.ensphere.veto.wysiwyg( '.redactor' );
		bindEvents();
		checkIfDefinedRulesAreEmpty();
		checkIfCustomFieldsAreEmpty();
		bindSortableRows();
	};

	return this;

};


jQuery(document).ready( function($){

	if( $('.edit.page, .create.page, .pages.list').length ) {

		/** Create new instance of the application */
		var app = new pages().init();
		
	}

});
